import { Components, Theme } from '@mui/material';

import { shadows } from '../colors';

export const iconButtonOverrides: Components<Theme>['MuiIconButton'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      height: 'fit-content',
      boxShadow: shadows.buttonSdw,
      backgroundColor: theme.palette.background.paper,
    }),
    colorInfo: ({ theme }) => ({
      color: 'currentcolor',
      border: '1px solid transparent',
      '&:hover': {
        borderColor: theme.palette.primary.main,
      },
    }),
    colorInherit: { backgroundColor: 'transparent', boxShadow: 'none' },
  },
};
